import React, { useState, useEffect, useContext } from 'react';
import Navbar from '../Layout/Navbar/Navbar';
import Footer from '../Layout/Footer/Footer';
import { FilterContext } from '../../context/FilterContext';
import Producto from '../Products/Producto';
import Select from 'react-select';

function Productos() {
  const fi = useContext(FilterContext);
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);
  return (
    <div>
      <Navbar checkScroll={false} />
      <div className="w-full m-auto relative pb-48 md:top-48 top-24">
        <div className="h-1/4 py-2 md:gap-8 w-full m-auto flex justify-center flex-wrap">
          <div className="md:basis-1/4 basis-full px-2 md:px-0">
            <label className="my-2 block text-sm text-gray-500">
              Aplicacion
            </label>

            {fi.state.aplicaciones && (
              <Select
                isMulti
                name="Aplicaciones"
                options={fi.state.aplicaciones.map((ap) => {
                  return { label: ap.nombre, value: ap.id };
                })}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Seleccionar"
                onChange={(e) =>
                  fi.dispatch({
                    type: 'set_aplicaciones_filter',
                    payload: { aplicaciones: e.map((ap) => ap.value) },
                  })
                }
                value={fi.state?.filtros?.aplicaciones?.map((fil) => {
                  return fi.state?.aplicaciones?.reduce((acc, item) => {
                    if (item.id == fil) {
                      return { ...acc, label: item.nombre, value: item.id };
                    } else {
                      return acc;
                    }
                  }, {});
                })}
              />
            )}
          </div>
          <div className="md:basis-1/4 basis-full px-2 md:px-0">
            <label className="my-2 block text-sm text-gray-500">Ambiente</label>

            {fi.state.ambientes && (
              <Select
                isMulti
                name="Ambientes"
                options={fi.state.ambientes.map((ap) => {
                  return { label: ap.nombre, value: ap.id };
                })}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Seleccionar"
                onChange={(e) =>
                  fi.dispatch({
                    type: 'set_ambientes_filter',
                    payload: { ambientes: e.map((ap) => ap.value) },
                  })
                }
                value={fi.state?.filtros?.ambientes?.map((fil) => {
                  return fi.state?.ambientes?.reduce((acc, item) => {
                    if (item.id == fil) {
                      return { ...acc, label: item.nombre, value: item.id };
                    } else {
                      return acc;
                    }
                  }, {});
                })}
              />
            )}
          </div>
          <div className="md:basis-1/4 basis-full px-2 md:px-0">
            <label className="my-2 block text-sm text-gray-500">
              Tipo de Lampara
            </label>

            {fi.state.lamparas && (
              <Select
                isMulti
                name="Lamparas"
                options={fi.state.lamparas.map((ap) => {
                  return { label: ap.nombre, value: ap.id };
                })}
                className="basic-multi-select"
                classNamePrefix="select"
                placeholder="Seleccionar"
                onChange={(e) =>
                  fi.dispatch({
                    type: 'set_lamparas_filter',
                    payload: { lamparas: e.map((ap) => ap.value) },
                  })
                }
                value={fi.state?.filtros?.lamparas?.map((fil) => {
                  return fi.state?.lamparas?.reduce((acc, item) => {
                    if (item.id == fil) {
                      return { ...acc, label: item.nombre, value: item.id };
                    } else {
                      return acc;
                    }
                  }, {});
                })}
              />
            )}
          </div>
        </div>
        <div className="flex flex-wrap pt-4">
          {fi.state.productosDisplay &&
            fi.state.productosDisplay.map((pr) => {
              return <Producto data={pr} />;
            })}
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Productos;
